import { render, staticRenderFns } from "./AdvProductGalleryWithVideo.vue?vue&type=template&id=21946e18"
import script from "./AdvProductGalleryWithVideo.vue?vue&type=script&lang=js"
export * from "./AdvProductGalleryWithVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports